import { Button } from "@blueprintjs/core";
import { IInputProps } from "./Input/types";
import { IInput } from "./types";
import { ILayoutProps } from "./Layout/types";
import "./style.scss";
import { isUndefined } from "lodash";
import React from "react";

export interface IOverrideProps {}

export interface IInputValidateProps extends IOverrideProps, IInputProps {}

export interface ILayoutValidateProps extends IOverrideProps, ILayoutProps {}

const Override = (props: React.PropsWithChildren<IInputValidateProps | ILayoutValidateProps>) => {
  const { template, mutators } = props;
  const { isOverridden, handleOverridden } = mutators;

  return (
    <React.Fragment>
      {!isUndefined((template as IInput).default) && (
        <div className="override-container">
          <Button
            className="override-button"
            disabled={!isOverridden?.(template.name)}
            icon="refresh"
            onClick={() => handleOverridden?.(template.name, false)}
            minimal
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default Override;
